import { render, staticRenderFns } from "./ColumnNextOrPreviousAction.vue?vue&type=template&id=5419ed82&"
import script from "./ColumnNextOrPreviousAction.vue?vue&type=script&lang=ts&"
export * from "./ColumnNextOrPreviousAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports